import React, { Component } from 'react';
import Formulario from './FormSeleccionarPeriodo';


class SeleccionarPeriodo extends Component{

    componentDidMount = () => {
        const { periodosList, parametrosEmpresa } = this.props;
        periodosList();
        parametrosEmpresa();
    }
    render(){
        const { periodoL, datos } = this.props;
        return(
           
            <Formulario
                periodoL={periodoL}
                datos={datos}
            />
           
        );
    } 
}

export default SeleccionarPeriodo;